import React, { memo, useMemo } from "react";
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import "./QuickStatItem.scss";

import Toast from "components/Toasts/Toast";
import CopyToast from "components/Toasts/CopyToast";

import { ReactComponent as CopyIcon } from "static/icons/copy-icon.svg";

const QuickStatsItem = memo(({
  value,
  name,
  percent,
  unit,
}) => {
  const { t } = useTranslation();

  const copyFunction = (e) => {
    navigator.clipboard.writeText(value);

    toast((t) => (
      <Toast
        {...t}
      >
        <CopyToast />
      </Toast>
    ),
      {
        duration: 2000,
      }
    );
  };

  const unitUpd = useMemo(() => {
    const unitArr = unit?.split('^');

    return {
      unit: unitArr?.[0],
      unitDegree: unitArr?.[1],
    };
  }, [unit]);

  return (
    <div
      className="stat-item"
      onClick={copyFunction}
    >
      <p className="stat-item__name">
        {t(name)}
      </p>

      <div className="stat-item__wrapper">
        <div className="stat-item__unit_container">
          <p>
            {Number.isInteger(value) ? value : value.toFixed(2)}
          </p>

          <div className="stat-item__unit_container">
            &nbsp;
            {unitUpd?.unit && !!value &&
              <span className="stat-item__unit">
                {unitUpd?.unit}
              </span>
            }

            {unitUpd?.unitDegree && !!value &&
              <span className="stat-item__unit_degree">
                {unitUpd?.unitDegree}
              </span>
            }
          </div>
        </div>

        <div
          className="stat-item__copy-icon_wrapper"
        >
          <CopyIcon />
        </div>
      </div>
    </div>
  );
});

export default QuickStatsItem;
